export default "__VITE_ASSET__QaIy7O0i__"